import Immutable from 'immutable';
import ActionTypes from '../constants/ActionTypes';

const initialState = {
    // dynamic values
    intensity: 1,
    crisis: false,
    crisisSound: false,
    instability: 1,
    instabilityDelta: 1,

    // static values
    minIntensity: 1,
    maxIntensity: 3,
    instabilityCrisisValue: 1000,
    crisisInitialInstabilityDelta: 4,
    intensitiesColors: {
        1: 0x00ff66,
        2: 0xff9900,
        3: 0xff3333,
    },
};

const getInstabilityState = (state) => {
    let intensity = state.get('intensity');
    // let instability = state.get('instability');
    // let instabilityDelta = state.get('instabilityDelta');
    // const instabilityCrisisValue = state.get('instabilityCrisisValue');
    let crisis = state.get('crisis');

    if (!crisis) {
        // instabilityDelta = state.get('crisisInitialInstabilityDelta');
        crisis = true;
        intensity = state.get('maxIntensity') - 1;
    } else if (crisis) {
        // instabilityDelta = 1;
        crisis = false;
        intensity = state.get('maxIntensity') - 1;
    }

    // instability += (instabilityDelta * (crisis ? -1 : 1));
    // instability = Math.min(Math.max(0, instability), instabilityCrisisValue);

    return state
        .set('intensity', intensity)
        // .set('instability', instability)
        // .set('instabilityDelta', instabilityDelta)
        .set('crisis', crisis);
};

const getIntensityState = (state, payload) => {
    const prevIntensity = state.get('intensity');
    // let instability = state.get('instability');
    // let instabilityDelta = state.get('instabilityDelta');
    // const instabilityCrisisValue = state.get('instabilityCrisisValue');
    const intensity = Math.min(Math.max(state.get('minIntensity'), payload.intensity), state.get('maxIntensity'));
    let crisis = state.get('crisis');

    // instability += (instabilityDelta * (crisis ? -1 : 1));
    // instability = Math.min(Math.max(0, instability), instabilityCrisisValue);

    if (crisis && intensity === state.get('minIntensity')) {
        // crisis = false;
        // instability = 1;
        // instabilityDelta = 1;
    }

    if (intensity !== prevIntensity) {
        // instability = 1;
        // instabilityDelta = 1;
    }

    return state
        .set('intensity', intensity)
        // .set('instability', instability)
        // .set('instabilityDelta', instabilityDelta)
        .set('crisis', crisis);
};

module.exports = (oldState, action) => {
    let state = oldState;
    if (typeof oldState === 'undefined') {
        state = Immutable.Map(initialState);
    }

    switch (action.type) {
    case ActionTypes.CRISIS_UPDATE_INTENSITY:
        // console.log('intense');
        return getIntensityState(state, action.payload);
    case ActionTypes.CRISIS_UPDATE_INSTABILITY:
        // console.log('insta');
        return getInstabilityState(state);
    case ActionTypes.CRISIS_UPDATE_INSTABILITY_DELTA:
        // console.log('delta');
        return state.set('instabilityDelta', action.payload.instabilityDelta);
    case ActionTypes.CRISIS_UPDATE_CRISIS:
        return state.set('crisis', action.payload.crisis);
    case ActionTypes.CRISIS_UPDATE_SOUND:
        return state.set('crisisSound', action.payload.crisisSound);
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./js/stores/CrisisStore.js